import React, { useEffect } from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import NotificationAlert from "react-notification-alert";
import { INSERT_MENUS, UPDATE_MENUS } from "../../constants";
import { useHistory } from "react-router-dom";
var filepath = "";
var deletedArr = [];
const UpdateMenu = (props) => {
  const navigate = useHistory();
  var parentArr = [];
  var childArr = [];

  props?.location?.state?.menus.map((parent, index) => {
    parent?.submenu.map((child, index) => {
      var subChildArr = [];
      child?.subsubmenu.map((subChild, index) => {
        subChildArr.push({
          name: subChild.name,
          displayname: subChild.displayname,
          icon: subChild.icon,
          id: subChild.id,
        });
      });
      childArr.push({
        id: child.id,
        name: child.name,
        displayname: child.displayname,
        icon: child.icon,
        subsubmenu: subChildArr,
      });
    });
    parentArr.push({
      id: parent.id,
      name: parent.name,
      displayname: parent.displayname,
      icon: parent.icon,
      submenus: childArr,
    });
  });

  const [parent, setParent] = React.useState({
    name: "",
    displayname: "",
    icon: "",
    submenus: [],
    id: "",
  });

  const [child, setChild] = React.useState([
    {
      name: "",
      displayname: "",
      icon: "",
      id: "",
      subsubmenu: [
        {
          name: "",
          displayname: "",
          icon: "",
          id: "",
        },
      ],
    },
  ]);

  const notificationAlertRef = React.useRef(null);
  useEffect(() => {
    setParent(parentArr[0]);
    setChild(childArr);
  }, []);

  const addSubMenu = () => {
    let childObj = [...child];
    let newSubMenu = {
      name: "",
      displayname: "",
      icon: "",
      subsubmenu: [
        {
          name: "",
          displayname: "",
          icon: "",
        },
      ],
    };

    childObj.push(newSubMenu);
    setChild(childObj);
  };
  const addSubChildMenu = (index) => {
    let j = child.map((item, i) => {
      let subchildObj = child[index].subsubmenu;
      if (i == index) {
        let newSubMenu = {
          name: "",
          displayname: "",
          icon: "",
        };
        subchildObj.push(newSubMenu);
        return [{ ...item, subchildObj }];
      }
      return item;
    });
    changeSubmenuHandler();
  };

  const removeSubChildMenu = (event, i, j, id) => {
    deletedArr.push(id);

    let new_document = child;
    let subChildArr = [];
    child.map((item, index) => {
      if (i == index) {
        subChildArr = item.subsubmenu.filter((dta, ind) => ind != j);
        return (new_document[i].subsubmenu = subChildArr);
      }
      // return item;
    });

    setChild(new_document);
    changeSubmenuHandler();
  };

  const removeChildMenu = (i, id) => {
    deletedArr.push(id);

    let remainChlds = child.filter((data, index) => index != i);

    setChild(remainChlds);
  };

  const changeSubmenuHandler = () => {
    let newmenus = [...child];
    let newmenusObj = child.map((item, i) => {
      return item;
    });
    setChild(newmenusObj);
  };

  const changeHandler = (event) => {
    const { name, value } = event.target;
    if (name === "icon") {
      const file = event.target.files[0];
      filepath = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        setParent({ ...parent, [name]: reader.result });
      };

      reader.onerror = (error) => {};
    } else {
      setParent({ ...parent, [name]: value });
    }
  };

  const changeHandlerChild = (event, i) => {
    const { name, value } = event.target;
    let childdata = child.map((item, index) => {
      if (i == index) {
        if (name === "icon") {
          var baseImg = [];
          const file = event.target.files[0];

          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = () => {
            baseImg.push(reader.result);
          };
          reader.onerror = (error) => {
            console.log("Error: ", error);
          };

          return { ...item, [name]: baseImg, imgname: file.name };
        } else {
          return { ...item, [name]: value };
        }
      }
      return item;
    });

    setChild(childdata);
  };

  const changeHandlerSubChild = (event, i, j) => {
    const { name, value } = event.target;
    let new_document = [...child];
    let subchilddata = child.map((item, index) => {
      if (i == index) {
        if (name === "icon") {
          var baseImg = [];
          const file = event.target.files[0];

          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = () => {
            baseImg.push(reader.result);
          };
          reader.onerror = (error) => {
            console.log("Error: ", error);
          };
          new_document[i].subsubmenu[j].imgname = file.name;

          return (new_document[i].subsubmenu[j][name] = baseImg);
        } else {
          return (new_document[i].subsubmenu[j][name] = value);
        }
      }
      return item;
    });

    setChild(new_document);
  };

  const submitThreeLayer = () => {
    var childBase = [];
    child.map((item, index) => {
      var subChildBase = [];
      item?.subsubmenu?.map((data, i) => {
        subChildBase.push({
          name: data.name,
          displayname: data.displayname,
          icon: data.icon.length == 1 ? data.icon[0] : data.icon,
          filename: data.imgname,
          id: data?.id?.toString() || "0",
        });
      });

      childBase.push({
        id: item?.id?.toString() || "0",
        name: item.name,
        displayname: item.displayname,
        icon: item.icon.length == 1 ? item.icon[0] : item.icon,
        filename: item.imgname,
        childmenus: subChildBase,
      });
    });

    let body = {
      // filename: "filepath",
      id: parent?.id?.toString(),
      name: parent.name,
      icon: parent.iconlength == 1 ? parent.icon[0] : parent.icon,
      displayname: parent.displayname,
      submenus: childBase,
      deleted: deletedArr,
    };
    axios
      .post(UPDATE_MENUS, body)
      .then((response) => {
        deletedArr = [];
        // props.btnSub(false)
       // props.isPopup(false);
        let options = {};
        options = {
          place: "tr",
          message: "Updated Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
        navigate.goBack()
       // navigate.push("/admin/user/menulist")
       // props.alerpoop(options);
      })
      .catch((error) => {
        console.log("????", error);
      });
  };

  return (
    <React.Fragment>
      <NotificationAlert ref={notificationAlertRef} />
      <div className="content pd-0">
          <Row>
            <Card className="mb-0">
              <CardBody style={{minHeight:"522px",overflow:"auto"}}>
                <Row>
                 <Col sm="12">
                    <h4 className="add-content" onClick={() =>
                          navigate.goBack()
                         // navigate.push("/admin/user/menulist")
                          } style={{"width":"185px"}}>
                      <Button className="btn btn-icon btn-link-add btn-sm mr-2">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </Button>
                      Update Menu
                    </h4>
                  </Col>
                  </Row>
                  <hr></hr>
        
            {/* Parent Menu */}
            <Row>
              <Col md="4" sm="12">
                <Label>Parent Icon</Label>
                <FormGroup>
                  <Input
                    placeholder="placeholder"
                    name="icon"
                    type="file"
                    accept=".jpg,.jpeg,.png,.svg" 
                    style={{
                      opacity: "1",
                      position: "initial",
                      border: "solid 1px #eee",
                    }}
                    onChange={changeHandler}
                  />
                </FormGroup>
              </Col>
              <Col md="4" sm="12" className="mt-4">
                <MDBInput
                  label="Menu Title"
                  type="text"
                  name="name"
                  value={parent?.name}
                  onChange={changeHandler}
                />
              </Col>
              <Col md="4" sm="12" className="mt-4">
                <MDBInput
                  label="Display Name "
                  type="text"
                  name="displayname"
                  value={parent?.displayname}
                  onChange={changeHandler}
                />
              </Col>
            </Row>

            <Row>
              <Col md="11" sm="12">
                <Row>
                  {child?.map((item, i) => {
                    return (
                      <>
                        <Card>
                          <CardBody
                            style={{ background: "rgba(247, 247, 245)" }}
                          >
                            <Row>
                              <Col sm="10">
                                <Row>
                                  <Col md="4" sm="12">
                                    <Label>Child Icon</Label>
                                    <FormGroup>
                                      <Input
                                        key={i}
                                        placeholder="placeholder"
                                        type="file"
                                        name="icon"
                                        accept=".jpg,.jpeg,.png,.svg" 
                                        value={child.icon}
                                        style={{
                                          opacity: "1",
                                          position: "initial",
                                          border: "solid 1px #eee",
                                        }}
                                        onChange={(val) =>
                                          changeHandlerChild(val, i)
                                        }
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md="4" sm="12" className="mt-4">
                                    <MDBInput
                                      key={i}
                                      label="SubMenu Tilte"
                                      type="text"
                                      value={item?.name}
                                      name="name"
                                      onChange={(val) =>
                                        changeHandlerChild(val, i)
                                      }
                                    />
                                  </Col>
                                  <Col md="4" sm="12" className="mt-4">
                                    <MDBInput
                                      key={i}
                                      label="SubMenu Path"
                                      type="text"
                                      value={item?.displayname}
                                      name="displayname"
                                      onChange={(val) =>
                                        changeHandlerChild(val, i)
                                      }
                                    />
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md="10">
                                    <Row>
                                      {item?.subsubmenu?.map((data, index) => {
                                        return (
                                          <>
                                            <Col md="11">
                                              <Row>
                                                <Col md="4" sm="12">
                                                  <Label>SubChild Icon</Label>
                                                  <FormGroup>
                                                    <Input
                                                      key={i}
                                                      placeholder="placeholder"
                                                      type="file"
                                                      accept=".jpg,.jpeg,.png,.svg" 
                                                      name="icon"
                                                      style={{
                                                        opacity: "1",
                                                        position: "initial",
                                                        border:
                                                          "solid 1px #eee",
                                                      }}
                                                      onChange={(val) =>
                                                        changeHandlerSubChild(
                                                          val,
                                                          i,
                                                          index
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col
                                                  md="3"
                                                  sm="12"
                                                  className="mt-4"
                                                >
                                                  <MDBInput
                                                    key={i}
                                                    label="SubMenu Tilte"
                                                    type="text"
                                                    value={data.name}
                                                    name="name"
                                                    onChange={(val) =>
                                                      changeHandlerSubChild(
                                                        val,
                                                        i,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </Col>
                                                <Col
                                                  md="5"
                                                  sm="12"
                                                  className="mt-4"
                                                >
                                                  <MDBInput
                                                    key={i}
                                                    label="SubMenu Path"
                                                    type="text"
                                                    value={data.displayname}
                                                    name="displayname"
                                                    onChange={(val) =>
                                                      changeHandlerSubChild(
                                                        val,
                                                        i,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </Col>
                                              </Row>
                                            </Col>

                                            <Col md="1">
                                              <Button
                                                className="btn btn-icon btn-remove-style mt-4"
                                                onClick={(val) =>
                                                  removeSubChildMenu(
                                                    val,
                                                    i,
                                                    index,
                                                    data.id
                                                  )
                                                }
                                              >
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                              </Button>
                                            </Col>
                                          </>
                                        );
                                      })}
                                    </Row>
                                  </Col>
                                  {item?.subsubmenu?.length > 0 && (
                                    <Col md="1" sm="12">
                                      <Button
                                        className="btn btn-icon btn-add-style mt-4"
                                        onClick={() => addSubChildMenu(i)}
                                      >
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                      </Button>
                                    </Col>
                                  )}
                                </Row>
                              </Col>
                              <Col md="2">
                                {item?.subsubmenu?.length == 0 && (
                                  <Button
                                    className="btn btn-icon btn-add-style mt-4"
                                    onClick={() => addSubChildMenu(i)}
                                  >
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                  </Button>
                                )}
                                <Button
                                  className="btn btn-icon btn-remove-style mt-4"
                                  onClick={() => removeChildMenu(i, item.id)}
                                >
                                  <i class="fa fa-minus" aria-hidden="true"></i>
                                </Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </>
                    );
                  })}
                </Row>
              </Col>
              <Col md="1" sm="12">
                <Button
                  className="btn btn-icon btn-add-style mt-4"
                  onClick={addSubMenu}
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </Button>
              </Col>
            </Row>

            <Col md="12" sm="12">
              <Button color="primary " className="btn btn-icon" type="button" onClick={submitThreeLayer}>
              <i className="tim-icons icon-double-right" />
              </Button>
            </Col>
         
            </CardBody>
            </Card>
          </Row>
        </div>
    </React.Fragment>
  );
};

export default UpdateMenu;
